import React, { useEffect, useRef } from 'react';

const BackgroundEffects = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;
    let startTime = null;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const nodes = Array.from({ length: 32 }, (_, i) => ({
      x: Math.random(),
      y: Math.random(),
      vx: (Math.random() - 0.5) * 0.00012,
      vy: (Math.random() - 0.5) * 0.00012,
      r: Math.random() * 1.2 + 0.4,
      phase: Math.random() * Math.PI * 2,
    }));

    const draw = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const w = canvas.width;
      const h = canvas.height;

      ctx.fillStyle = '#080c10';
      ctx.fillRect(0, 0, w, h);

      ctx.strokeStyle = 'rgba(74,90,103,0.04)';
      ctx.lineWidth = 0.5;
      const gridSize = 80;
      for (let x = 0; x < w; x += gridSize) {
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h); ctx.stroke();
      }
      for (let y = 0; y < h; y += gridSize) {
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke();
      }

      nodes.forEach(n => {
        n.x += n.vx; n.y += n.vy;
        if (n.x < 0 || n.x > 1) n.vx *= -1;
        if (n.y < 0 || n.y > 1) n.vy *= -1;
      });

      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const dx = (nodes[i].x - nodes[j].x) * w;
          const dy = (nodes[i].y - nodes[j].y) * h;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 160) {
            const alpha = (1 - dist / 160) * 0.12;
            ctx.strokeStyle = `rgba(74,90,103,${alpha})`;
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(nodes[i].x * w, nodes[i].y * h);
            ctx.lineTo(nodes[j].x * w, nodes[j].y * h);
            ctx.stroke();
          }
        }
      }

      nodes.forEach((n) => {
        const pulse = Math.sin(elapsed * 0.001 + n.phase) * 0.5 + 0.5;
        const nx = n.x * w;
        const ny = n.y * h;
        const grad = ctx.createRadialGradient(nx, ny, 0, nx, ny, n.r * 6);
        grad.addColorStop(0, `rgba(74,90,103,${0.6 * pulse})`);
        grad.addColorStop(1, 'rgba(74,90,103,0)');
        ctx.beginPath(); ctx.arc(nx, ny, n.r * 6, 0, Math.PI * 2);
        ctx.fillStyle = grad; ctx.fill();
        ctx.beginPath(); ctx.arc(nx, ny, n.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(74,90,103,${0.7 * pulse + 0.3})`; ctx.fill();
      });

      const blobs = [
        { x: 0.8, y: 0.1, color: '#4a5a67', r: 0.35 },
        { x: 0.1, y: 0.85, color: '#99687c', r: 0.28 },
        { x: 0.5, y: 0.5, color: '#2e3c47', r: 0.22 },
      ];
      blobs.forEach(b => {
        const t = elapsed * 0.00006;
        const cx = (b.x + Math.sin(t + b.r) * 0.05) * w;
        const cy = (b.y + Math.cos(t * 0.8 + b.r) * 0.04) * h;
        const r = b.r * Math.min(w, h);
        const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
        grad.addColorStop(0, b.color + '18');
        grad.addColorStop(1, b.color + '00');
        ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fillStyle = grad; ctx.fill();
      });

      animationId = requestAnimationFrame(draw);
    };

    animationId = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed', inset: 0,
        width: '100vw', height: '100vh',
        zIndex: -10, display: 'block',
      }}
    />
  );
};

export default BackgroundEffects;